import React from 'react';

interface SelectLabelProps {
    id: string;
    name: string;
    label?: string;
    ariaLabel?: string;
    className?: string;
    action: '' | 'view';
    foco: 'sim' | 'nao';
    required?: 'sim' | 'nao';
    valorSelecionado: string;
    campoExibicaoRegistro: string;
    campoIdentificadorRegistro: string;
    referencia: React.LegacyRef<HTMLSelectElement>;
    itens: Array<{ [key: string]: string | number; }>;
    onChange?: (e: React.FormEvent<HTMLSelectElement>) => void;
}

export function SelectLabel(props: SelectLabelProps) {
    let selectClass = 'form-select rxlib-select-label';

    if ((props.className) && (props.className !== '')) {
        selectClass = props.className + ' ' + selectClass;
    }

    const hiddenInputId = `${props.id}-hidden`;
    const labelId = `${props.id}-label`;
    const normalizedLabel = typeof props.label === 'string' ? props.label.trim() : '';
    const normalizedAriaLabel = typeof props.ariaLabel === 'string' ? props.ariaLabel.trim() : '';
    const labelText = normalizedLabel !== '' ? normalizedLabel : 'Selecione uma opção';
    const accessibleLabel = normalizedAriaLabel !== '' ? normalizedAriaLabel : labelText;
    const selectKey = `${props.id}-${props.valorSelecionado}-${props.action}`;

    let selectRequired = 'sim';
    if (props.required !== undefined) {
        selectRequired = props.required;
    }

    const isView = props.action === 'view';
    const isAutoFocus = props.foco === 'sim';
    const isRequired = selectRequired === 'sim';

    return (
        <>
            <label className='form-label d-block' htmlFor={props.id}>
                <span id={labelId} className='d-block'>{labelText}</span>
                <select
                    key={selectKey}
                    ref={props.referencia}
                    name={props.name}
                    id={props.id}
                    className={selectClass}
                    title={accessibleLabel}
                    onChange={props.onChange}
                    autoFocus={isAutoFocus}
                    required={isRequired}
                    disabled={isView}
                    aria-label={accessibleLabel}
                    aria-labelledby={labelId}
                    defaultValue={props.valorSelecionado}>
                    {props.itens.map((item, index) => (
                        <option key={index} value={item[props.campoIdentificadorRegistro]}>
                            {item[props.campoExibicaoRegistro]}
                        </option>
                    ))}
                </select>
            </label>
            {
                (isView)
                    ? <input type='hidden' name={props.name} id={hiddenInputId} value={props.valorSelecionado} readOnly />
                    : ''
            }
        </>
    );
}